export default "__VITE_ASSET__0a5212e2__"